import ApiService from './api.service';

class TicketService {
  async list() {
    try {
      const response = await ApiService.get('/ticket');
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async create(data) {
    try {
      const response = await ApiService.post('/ticket/add', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async update(data) {
    try {
      const response = await ApiService.put('/ticket/update', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async delete(id) {
    try {
      const response = await ApiService.delete('/ticket/delete', { id });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async exportOrderedTicketsExcel() {
    try {
      const filename = `tickets-commandes-${new Date().toISOString().split('T')[0]}.xlsx`;
      await ApiService.downloadFile('/export/ordered-tickets/excel', filename);
    } catch (error) {
      throw error;
    }
  }

  async listOrderedTickets(params = {}) {
    try {
      const query = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          query.append(key, value);
        }
      });

      const endpoint = query.toString()
        ? `/ordered-tickets?${query.toString()}`
        : '/ordered-tickets';

      const response = await ApiService.get(endpoint);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default new TicketService(); 